import { render, staticRenderFns } from "./BuyOrderDetailsDesktop.vue?vue&type=template&id=24111426&scoped=true"
import script from "./BuyOrderDetailsDesktop.vue?vue&type=script&lang=js"
export * from "./BuyOrderDetailsDesktop.vue?vue&type=script&lang=js"
import style0 from "./BuyOrderDetailsDesktop.vue?vue&type=style&index=0&id=24111426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24111426",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QField from 'quasar/src/components/field/QField.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBanner,QBadge,QBtn,QChip,QInput,QTable,QTr,QSpace,QField,QTooltip,QCardActions,QDialog});qInstall(component, 'directives', {ClosePopup});
